<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ad80Qr/tc-custom/buylink_9781982105587_cover.jpg?1718079134341?1730525600690" alt="This image is the cover for the book Sleepless in Scotland, The MacLean Curse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleepless in Scotland, The MacLean Curse
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i> bestselling author Karen Hawkins continues to delight with this amusing and sizzling story of Regency escapades, when a proper English miss and a dashing Highland laird find their mutual passion.</b><br/><br/>When sensible Catriona Hurst sets off in pursuit of her wild twin sister, Caitlyn—whose plan to trap the handsome laird of Clan MacLean into marriage will lead her to sure disaster—she never expects the journey to end with her own wedding. First Triona is caught in MacLean’s carriage, then she’s roundly scolded, and then—to her shocked surprise— thoroughly kissed! She is caught, body and soul, by the laird’s enigmatic younger brother, Hugh MacLean, who had set a trap for the unprincipled sister and refuses to believe that he’s caught the other. While Hugh is enchanted by Triona’s delightful response to his kiss, he soon realizes that she is not who he thought, but an innocent whom honor demands he wed immediately. And he also discovers that letting the passionate Triona into his bed is far easier than keeping her out of his many concerns—even the ones he’d planned to keep secret!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Hawkins
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> and <I>USA TODAY&#160;</I>bestselling author Karen Hawkins writes novels that have been praised as touching, witty, charming, and heartwarming. A native Southerner who grew up in the mountains of East Tennessee where storytelling is a way of life, Karen recently moved to frosty New England with her beloved husband and multiple foster dogs. The Dove Pond series is a nod to the thousands of books that opened doors for her to more adventures, places, and discoveries than she ever imagined possible.&#160;To find out more about Karen, check in with her at Facebook.com/AuthorKarenHawkins, on Instagram @KarenHawkinsAuthor, and on her website&#160;KarenHawkins.com.<BR><BR>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fee6b1d4